import axios from "axios";
import Vue from "vue";
import objectUtils from "../../util/objectUtils";
import helper from "../../util/helper";
import moment from "moment";

const getDefaultSelectedConnectedTrainDiscount = () => {
  return {
    fromScheduleId: null,
    toScheduleId: null,
    startDate: null,
    endDate: null,
    fromScheduleDiscount: null,
    toScheduleDiscount: null,
  };
};

export default {
  state: () => ({
    selectedConnectedTrainDiscount: getDefaultSelectedConnectedTrainDiscount(),
  }),

  mutations: {
    setSelectedConnectedTrainDiscount(state, selectedConnectedTrainDiscount) {
      Vue.set(state, "selectedConnectedTrainDiscount", selectedConnectedTrainDiscount);
    },
    setDefaultSelectedConnectedTrainDiscount(state) {
      Vue.set(state, "selectedConnectedTrainDiscount", getDefaultSelectedConnectedTrainDiscount());
    },
  },

  actions: {
    //TODO: load, update, create
    createConnectedTrainDiscount: (context, request) => {
      return axios
        .post(context.getters.getMcServiceUrl + "/connected-train-discount/entity", request, {})
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },

    loadConnectedTrainDiscounts: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/connected-train-discount/entity").then((response) => {
        return response.data;
      });
    },

    loadConnectedTrainDiscount: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/connected-train-discount/entity/" + request.id).then((response) => {
        return response.data;
      });
    },

    loadPublishedConnectedTrainDiscounts: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/connected-train-discount/entity/published").then((response) => {
        return response.data;
      });
    },

    loadSelectedConnectedTrainDiscountHistory: (context, connectedTrainDiscount) => {
      return axios.get(context.getters.getMcServiceUrl + "/connected-train-discount/history/" + connectedTrainDiscount.id, {}).then((response) => {
        return response.data;
      });
    },

    deleteConnectedTrainDiscount: (context, connectedTrainDiscount) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/connected-train-discount/entity/" + connectedTrainDiscount.id)
        .then((response) => {
          let intents = [];
          intents.push(response.data);
          connectedTrainDiscount.intents = intents;
          connectedTrainDiscount.intentId = response.data.id;
          return connectedTrainDiscount;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },
    deleteDraftConnectedTrainDiscount: (context, connectedTrainDiscount) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/connected-train-discount/draft/" + connectedTrainDiscount.intentId)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },

    publishConnectedTrainDiscount: (context, connectedTrainDiscount) => {
      return axios.get(context.getters.getMcServiceUrl + "/connected-train-discount/publish/" + connectedTrainDiscount.intentId).then((response) => {
        if (response.data) {
          response.data.intentId = 0;
        }
        //Fixme: intents type CREATE_STATION ise get isteği atılmalı.
        if (connectedTrainDiscount.intents[0].type === "DELETE_CONNECTED_TRAIN_DISCOUNT") {
          let connectedTrainDiscounts = context.getters.getSegments;
          connectedTrainDiscounts.splice(connectedTrainDiscounts.indexOf(connectedTrainDiscount), 1);
          context.commit("setconnectedTrainDiscounts", connectedTrainDiscounts);
        }
        return response.data;
      });
    },

    rejectConnectedTrainDiscount: (context, connectedTrainDiscount) => {
      return axios.get(context.getters.getMcServiceUrl + "/connected-train-discount/reject/" + connectedTrainDiscount.intentId).then((response) => {
        helper.recallOrRejectEntity(connectedTrainDiscount, "connectedTrainDiscount");
        return response.data;
      });
    },

    sendToApprovalConnectedTrainDiscounts: (context, connectedTrainDiscount) => {
      return axios.get(context.getters.getMcServiceUrl + "/connected-train-discount/sendToApproval/" + connectedTrainDiscount.intentId).then((response) => {
        if (connectedTrainDiscount.intents[0].type === "CREATE_CONNECTED_TRAIN_DISCOUNT") {
          connectedTrainDiscount.intents[0].status = "WAITING_APPROVAL";
        } else if (connectedTrainDiscount.intents[0].type === "UPDATE_CONNECTED_TRAIN_DISCOUNT") {
          connectedTrainDiscount.intents[0].status = "WAITING_APPROVAL";
        }
        return response.data;
      });
    },

    recallConnectedTrainDiscount: (context, connectedTrainDiscount) => {
      return axios.get(context.getters.getMcServiceUrl + "/connected-train-discount/recall/" + connectedTrainDiscount.intentId).then((response) => {
        helper.recallOrRejectEntity(connectedTrainDiscount, "connectedTrainDiscount");
        return response.data;
      });
    },
    cancelConnectedTrainDiscount: (context, connectedTrainDiscount) => {
      return axios.get(context.getters.getMcServiceUrl + "/connected-train-discount/cancel/" + connectedTrainDiscount.intentId).then((response) => {
        return response.data;
      });
    },
  },

  getters: {
    getSelectedConnectedTrainDiscount: (state) => {
      return state.selectedConnectedTrainDiscount;
    },
  },
};
